import Service from '../../../views/socialized-service/e-commerce/e-commerce.service';
export default {
  data: () => {
    return {
      list: []
    };
  },
  created() {
    this.getService();
  },
  methods: {
    getService() {
      Service.getProductList({
        cateCodeNew: '005',
        pageNum: 1,
        pageSize: 4,
        tenantId: '66aaf784247b9fffdb5eba0b'
      }).then(res => {
        this.list = res.data.list;
      });
    },

    toDetail(item) {
      this.$router.push('/socialized-service/e-commerce/detail?id=' + item.id);
    }
  }
};

